import { Directive } from '@angular/core';

import { BaseWorkspaceComponent } from 'cms/workspace/workspace-generic-classes/base-workspace.component';
import { IdtComponentSettings } from 'shared/idt-components/idt-components-cms.model';


@Directive()
export class BaseRenderComponent<T extends IdtComponentSettings>
  extends BaseWorkspaceComponent<T> {
  // The signature of this class matches the one of the parent class because some render components are used in the
  //  workspace too, and therefore they have to be the same.
}
